import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr'; // <-- Importa ToastrService
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toastEl) => {
      toastEl.addEventListener('mouseenter', Swal.stopTimer);
      toastEl.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });


  constructor(private toastr: ToastrService) {     
  } // Inyecta ToastrService

    // Método genérico
  show(icon: SweetAlertIcon, title: string, text?: string) {
    return this.toast.fire({
      icon,
      title,
      text,
    });
  }

  /** Muestra un mensaje de éxito */
  showSuccess(message: string, title?: string): void {
    this.toast.fire({
      icon: 'success',
      title,
      text: message,
    });
  }

  /** Muestra un mensaje de error */
  showError(message: string, title?: string): void {
     this.toast.fire({
      icon: 'error',
      title,
      text: message,
    });
  }

  /** Muestra un mensaje de advertencia */
  showWarning(message: string, title?: string): void {    
     this.toast.fire({
      icon: 'warning',
      title,
      text: message,
    });
  }

  /** Muestra un mensaje de información */
  showInfo(message: string, title?: string): void {
     this.toast.fire({
      icon: 'info',
      title,
      text: message,
    });
  }

}